import { Mail, Phone, Clock, ShieldCheck } from "lucide-react";
import { Reveal, PageHero } from "@/components/bits";
import { QuoteForm } from "@/components/forms";
import { COMPANY } from "@/lib/data";

export default function QuotePage() {
  return (
    <main>
      <PageHero
        overlap
        eyebrow="Request a Quote"
        title="Tell us the lane. We'll bring the rate."
        testid="quote-page-title"
        lead={`Three quick steps and your request lands directly on our dispatch desk at ${COMPANY.email}. Expect rates within the hour during dispatch hours.`}
      />

      <section className="pb-16 lg:pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-start relative z-10 -mt-24 lg:-mt-28">
          <div className="lg:col-span-8" data-testid="quote-form-container">
            <QuoteForm />
          </div>
          <aside className="lg:col-span-4 space-y-5">
            <Reveal delay={0.1}>
              <div className="card p-7" data-testid="quote-aside-response">
                <div className="h-11 w-11 rounded-2xl bg-signal/10 flex items-center justify-center"><Clock className="h-5 w-5 text-corpblue" /></div>
                <h3 className="mt-4 font-display text-lg font-bold text-ink">Fast turnaround</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                  Quotes usually come back within the hour during dispatch hours, and always within one business day.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.16}>
              <div className="card p-7" data-testid="quote-aside-contact">
                <div className="h-11 w-11 rounded-2xl bg-signal/10 flex items-center justify-center"><Mail className="h-5 w-5 text-corpblue" /></div>
                <h3 className="mt-4 font-display text-lg font-bold text-ink">Prefer email or phone?</h3>
                <a href={`mailto:${COMPANY.email}`} data-testid="quote-aside-email" className="mt-2 block text-sm font-semibold text-ink hover:text-corpblue transition-colors">
                  {COMPANY.email}
                </a>
                <a href={`tel:${COMPANY.phone.replace(/[^+\d]/g, "")}`} data-testid="quote-aside-phone" className="mt-1 flex items-center gap-2 text-sm font-semibold text-ink hover:text-corpblue transition-colors">
                  <Phone className="h-3.5 w-3.5 text-corpblue" /> {COMPANY.phone}
                </a>
                <p className="mt-2 text-xs text-slate-500">24/7 dispatch line</p>
              </div>
            </Reveal>
            <Reveal delay={0.22}>
              <div className="panel-reference p-7" data-testid="quote-aside-promise">
                <ShieldCheck className="h-6 w-6 text-gold" />
                <h3 className="mt-4 font-display text-lg font-bold text-white">Zero double-brokerage</h3>
                <p className="mt-2 text-sm text-slate-300 leading-relaxed">
                  Your freight is only tendered to carriers we vet ourselves — in writing, on every load.
                </p>
              </div>
            </Reveal>
          </aside>
        </div>
      </section>
    </main>
  );
}
